import { render } from "./NewPartner.vue?vue&type=template&id=1e81af73"
import script from "./NewPartner.vue?vue&type=script&lang=js"
export * from "./NewPartner.vue?vue&type=script&lang=js"

import "./NewPartner.vue?vue&type=style&index=0&id=1e81af73&lang=scss"

import exportComponent from "/Users/andersnielsen/Sites/demo-leverandoroverblik/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__